var bighouse = bighouse || {};

bighouse.map = (function () {

    var map;
    var maps = [];
    var markers = [];
    var haveInit = false;
    var livekey = "AIzaSyDXt6w9cyMlYBWTQjVuadiOpHzLg9DolYQ"; // Gareth's
    var devkey = "AIzaSyCJa8g4V8djOVL1rukAyo6Q0vTU0qBLKdY"; //3sixty test

    function init(){
        if ($('.js-map').length > 0) {     
            insertScript('initMap');
        } 
    }


    function insertScript(callback){

        if(haveInit)
            return;

        haveInit = true;

        var key = livekey;

        if( document.location.host.indexOf('localhost') !== -1  ){
            key = devkey;
        }

        if (null === navigator.userAgent.match(/IEMobile/i)) {
            var e = document.createElement("script");
            e.type = "text/javascript";
            e.src = "https://maps.googleapis.com/maps/api/js?key=" + key + "&callback=bighouse.map." + callback;
            document.body.appendChild(e);
        }
    }


    function initMap() {
        
        $('.js-map').each(function( index ){

            var mapId = $(this).attr('id');
            var lat = parseFloat( $(this).attr('data-lat'), 10);
            var long = parseFloat( $(this).attr('data-long'), 10);
            var zoom = parseInt( $(this).attr('data-zoom'));

            var latlong = {lat: lat, lng: long};

            maps[index] = new google.maps.Map(document.getElementById(mapId), {
                center: latlong,
                zoom: zoom,
                disableDefaultUI: true,
                styles: bighouse.mapjson.defaultStyle
            });


            var image = '/assets/img/googlemap/bhe-pin.png';

            markers[index] = new google.maps.Marker({
                position: latlong,
                map: maps[index],
                icon: image
            });
        });
    }


    return {
        init: init,
        initMap: initMap
    };
})();